import { useTranslation } from "react-i18next";
import { FaUserCheck } from "react-icons/fa";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { isPlayerLinkedToUser, type PlayerMetadata } from "@/lib/v2/playerLink";
import { cn } from "@/lib/utils";

interface PlayerAccountBadgeProps {
  metadata?: PlayerMetadata;
  size?: "sm" | "md";
  className?: string;
}

export function PlayerAccountBadge({
  metadata,
  size = "sm",
  className,
}: PlayerAccountBadgeProps) {
  const { t } = useTranslation();

  if (!isPlayerLinkedToUser(metadata)) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="outline"
          className={cn(
            "gap-1 font-normal shrink-0 border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
            size === "sm" ? "px-1.5 py-0 text-[10px]" : "px-2 py-0.5 text-xs",
            className
          )}
        >
          <FaUserCheck className={size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3"} aria-hidden />
          {t("v2.squad.account.linked")}
        </Badge>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[220px]">
        {t("v2.squad.account.linkedHint")}
      </TooltipContent>
    </Tooltip>
  );
}
